/* eslint-disable @typescript-eslint/camelcase */
import { AppService } from './AbstractService';

export default class ShareService extends AppService {
  public getShare(id: string) {
    return this.makeRequest('GET', `/shares/${id}`);
  }

  public getShareSummary(period: string) {
    return this.makeRequest('GET', `/shares/summary?period=${period}`);
  }
}
